<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!--<div class="sf-col sf-col-7">-->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<mdj-m-graph-search ref="search" :scrId="scrId" @refreshCols="refreshCols" @doLayoutTb="doLayoutTb" @ResetPage="ResetPage"/>
				</sf-card>
			</div>
		
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 border-0 bg-transparent">
					<mdj-m-graph-chart ref="graph" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			
			<div class="sf-col sf-col-13">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<mdj-m-graph-table ref="table" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
		
		</div>
	</div>
</template>

<script>
import MdjMGraphSearch from './Search/MdjMGraphSearch.vue';
import MdjMGraphTable from './Table/MdjMGraphTable.vue';
import MdjMGraphChart from './Table/MdjMGraphChart.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { MdjMGraphSearch, MdjMGraphTable, MdjMGraphChart },
	methods: {
		Refresh() {
			this.$refs.search.searchList();
		},
		refreshCols(){
			this.$refs.table.refreshCols();
		},
		doLayoutTb(){
			this.$refs.table.doLayoutTb();
		},
		ResetPage(){
			this.$refs.table.resetPage();
		}
	}
};
</script>

<style></style>
